import getStore from 'services/getStore';
import { State } from 'store/store';

const bulletStyles = (bulletColor: string, textColor: string = '') => {
  const state = getStore().getState() as State;

  const margin = state?.theme?.margin || 0;

  const notHeadings = 'not:(h1 ul, h2 ul, h3 ul, h4 ul, h5 ul, h6 ul)';

  return {
    'ul, ol': {
      marginLeft: `20px`,
    },

    // [`ul${notHeadings}, ol${notHeadings}`]: {
    //   marginLeft: `${margin + 20}px`,
    // },

    // 'h1 ul, h2 ul, h3 ul, h4 ul, h5 ul, h6 ul': {
    //   marginLeft: `20px !important`,
    // },

    'ul li': {
      paddingLeft: '7px',
    },

    'ol li': {
      paddingLeft: '7px',
    },

    ...(bulletColor && {
      li: {
        color: `${bulletColor} !important`,
      },
    }),
  };
};

export default bulletStyles;
